import { render, staticRenderFns } from "./BudgetExtend.vue?vue&type=template&id=5057384d&"
import script from "./BudgetExtend.vue?vue&type=script&lang=js&"
export * from "./BudgetExtend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports